<div class="pb-3">
  <div class="pb-2 mt-2 is-flex is-justify-content-end">
    <radio
      [options]="radioOptions"
      [controlled]="true"
      name="dataCycle"
      [value]="dataCycle"
      (onChange)="dataCycleChange($event)"
    ></radio>
  </div>
  <payment-card
    *ngFor="let payment of payments"
    [payment]="payment"
    [readonly]="isReadonly"
    [currency]="currency"
    (onCreatePayment)="handleCreatePayment(payment)"
    (onUpdatePayment)="handleUpdatePayment($event)"
    (onDeletePayment)="handleDeletePayment($event)"
    (onDownloadPayment)="handleDownloadPayment($event)"
    (onClose)="expandedId = null"
    (onOpen)="expandedId = payment.id"
    [open]="expandedId == payment.id"
    [isPaymentDownloading]="isPaymentDownloading"
    [isCurrentCycle]="isCurrentCycle(payment)"
  ></payment-card>

  <content-loading *ngIf="isLoading"></content-loading>

  <p
    translationEditableDirective="NO_DATA"
    *ngIf="payments.length === 0 && !isLoading && !getField(['compound'])"
    class="is-flex py-4 my-4 is-justify-content-center is-align-items-center"
    style="min-height: 250px"
  >
    {{ 'NO_DATA' | translate }}
  </p>

  <div
    *ngIf="payments.length === 0 && !isLoading && !!getField(['compound'])"
    class="is-flex py-4 my-4 is-justify-content-center is-align-items-center is-flex-direction-column"
    style="min-height: 250px"
  >
    <p>
      <span translationEditableDirective="NO_DATA_COMPOUND_LICENSE">{{
        'NO_DATA_COMPOUND_LICENSE' | translate
      }}</span>
      <a
        [routerLink]="['/compounds', getField(['compound', 'id'])]"
        class=""
        *ngxPermissionsOnly="['COMPOUNDS']"
      >
        {{ getField(['compound', 'code']) }}
      </a>
      <span *ngxPermissionsExcept="['COMPOUNDS']" class="ml-1">{{
        getField(['compound', 'code'])
      }}</span>
    </p>
    <p translationEditableDirective="NO_DATA_COMPOUND_PAYMENTS">
      {{ 'NO_DATA_COMPOUND_PAYMENTS' | translate }}
    </p>
  </div>

  <div class="modal is-active" *ngIf="isPaymentFormOpen">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 600px">
      <div class="modal-card-head">
        <span
          class="modal-card-title"
          [translationEditableDirective]="
            form.get('action').value === 'create'
              ? 'CREATE_PAYMENT'
              : 'UPDATE_PAYMENT'
          "
        >
          {{
            (form.get('action').value === 'create'
              ? 'CREATE_PAYMENT'
              : 'UPDATE_PAYMENT'
            ) | translate
          }}
        </span>
        <button
          class="delete"
          (click)="isPaymentFormOpen = false"
          aria-label="close"
        ></button>
      </div>
      <form [formGroup]="form" class="modal-card-body">
        <div class="field">
          <label class="label" translationEditableDirective="AMOUNT">{{
            'AMOUNT' | translate
          }}</label>
          <div class="control">
            <number-input
              formControlName="amount"
              [inputClass]="{
                'is-danger': hasPaymentError('amount'),
                input: true
              }"
              [value]="getField(['amount'])"
            />
          </div>
          <p class="help is-danger" *ngIf="hasPaymentError('amount')">
            {{ getPaymentError('amount') }}
          </p>
        </div>
        <div class="field">
          <label
            class="label"
            translationEditableDirective="PAYMENT_PURPOSES"
            >{{ 'PAYMENT_PURPOSES' | translate }}</label
          >
          <div class="control">
            <ng-select
              [items]="paymentPurposes"
              formControlName="paymentPurposeId"
              [multiple]="false"
              [closeOnSelect]="true"
              [ngClass]="{ 'is-danger': hasPaymentError('paymentPurposeId') }"
              bindLabel="name"
              bindValue="id"
            >
            </ng-select>
          </div>
          <p class="help is-danger" *ngIf="hasPaymentError('paymentPurposeId')">
            {{ getPaymentError('paymentPurposeId') }}
          </p>
        </div>
        <div class="field">
          <label class="label" translationEditableDirective="BANK_ID">{{
            'BANK_ID' | translate
          }}</label>
          <div class="control">
            <input
              class="input"
              formControlName="transactionId"
              type="text"
              [ngClass]="{ 'is-danger': hasPaymentError('transactionId') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasPaymentError('transactionId')">
            {{ getPaymentError('transactionId') }}
          </p>
        </div>
        <div class="field">
          <label class="label" translationEditableDirective="PAYMENT_DATE">{{
            'PAYMENT_DATE' | translate
          }}</label>
          <div class="control">
            <input
              class="input"
              formControlName="paymentDate"
              type="date"
              [ngClass]="{ 'is-danger': hasPaymentError('paymentDate') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasPaymentError('paymentDate')">
            {{ getPaymentError('paymentDate') }}
          </p>
        </div>
        <div class="field">
          <label class="label" translationEditableDirective="NOTES">{{
            'NOTES' | translate
          }}</label>
          <div class="control">
            <textarea
              class="textarea"
              formControlName="notes"
              rows="2"
              [ngClass]="{ 'is-danger': hasPaymentError('notes') }"
            ></textarea>
          </div>
          <p class="help is-danger" *ngIf="hasPaymentError('notes')">
            {{ getPaymentError('notes') }}
          </p>
        </div>
      </form>
      <footer class="modal-card-foot">
        <button
          class="button is-success"
          [ngClass]="{
            'is-loading': isPaymentCreateLoading || isPaymentUpdateLoading
          }"
          type="button"
          (click)="onPaymentSubmit()"
          translationEditableDirective="SAVE"
        >
          {{ 'SAVE' | translate }}
        </button>
        <button
          class="button"
          (click)="isPaymentFormOpen = false"
          translationEditableDirective="CANCEL"
        >
          {{ 'CANCEL' | translate }}
        </button>
      </footer>
    </div>
  </div>
</div>
